import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import CustomFormInput from "../components/CustomFormInput";
import { useNavigate } from "react-router-dom";
import { PasswordValidateField } from "../validate/password";
import ErrorFilter from '../helper/errorFilter';
import { forgotPassword } from "../controller";
import { encryptAndStoreLoc } from "../helper/localStorage";
import SingleError from "../helper/SingleError";
import { toast } from "react-toastify";
import { requestHandler } from "../helper";

function ResetPassword() {
  const [errors, setErrors] = useState({});
  const [email, setEmail] = useState("");
  const [submitCount, setSubmitCount] = useState(0);

  const navigate = useNavigate();
  const requireField = ["email"];

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    let newValue = type === "checkbox" ? checked : value;
    if (submitCount > 0) {
      let validationErrors = PasswordValidateField({ ...email, [name]: value });
      validationErrors = ErrorFilter(validationErrors, requireField);

      if (Object.keys(validationErrors).length === 0) {
        delete errors[name];
      }
    }
    setEmail(newValue);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitCount(prevCount => prevCount + 1);
    const updatedValues = { email };
    let validationErrors = PasswordValidateField(updatedValues);
    validationErrors = ErrorFilter(validationErrors, requireField);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      await requestHandler(async () => await forgotPassword(updatedValues),
        null,
        (res) => {
          toast.success(res.message);
          const otpStartTime = Math.floor(Date.now() / 1000); // seconds since epoch
          encryptAndStoreLoc("otpStartTime", otpStartTime);
          encryptAndStoreLoc("isValidate", 1);
          navigate("/verify-email", { state: { email: email } });
        },
        () => { });
    }
  }


  useEffect(() => {
    document.title = "Always Outdoors | Forgot Password";
    // eslint-disable-next-line
  }, [window.location.pathname])

  return (
    <div className="login-wrapper">
      <div className="container">
        <Row className="justify-content-center">
          <Col xxl={5} xl={6} lg={7} md={9}>
            <div className="login-card">
              <div className="login-logo">
                <img
                  src="/images/svg/logo.svg"
                  className="img-fluid"
                  alt="logo"
                />
              </div>
              <h4>Reset Password</h4>
              <p>Please enter your registered email address to receive verification code.</p>
              <CustomFormInput
                type="email"
                label="Email Address"
                placeholder="Enter your email"
                id="email"
                value={email}
                onChange={handleChange}
                name='email'
              />
              <SingleError error={errors?.email} />
              <button type='button' onClick={handleSubmit} className="btn btn-primary w-100 mt-1">
                Submit
              </button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default ResetPassword;
